<script setup>
import {onMounted, ref, watch} from "vue";
import { t } from "@/controllerLK/GlobusLocalization";
import EditIcon from "@/assets/icons/EditIcon.vue";
import {useUser} from "@/store/user";
import LKUserAvatar from "@/pages/LKPage/LKWindow/LKProfileWindow/LKUserAvatar.vue";
import {useStore} from "@/store";

const store = useStore();
const userStore = useUser();

onMounted(async () => {
  Object.assign(userFormData.value, await userStore.getUser());

  userFormData.value.phone = getPhoneCode(userFormData.value.phone);

  setupWatcher();
});


// Телефоный код

const activePhoneCode = ref({"code": "+7", "phone": ""});

const getPhoneCode = (phone) => {
  const codes = ["+375", "+381", "+7"];
  const matched = codes.find(code => phone.startsWith(code));

  if (matched) {
    activePhoneCode.value.code = matched;
    activePhoneCode.value.phone = phone.slice(matched.length).trim();
    return phone.slice(matched.length).trim();
  }
  activePhoneCode.value.phone = phone;
  return phone;
};


const phoneCodeList = [
  {
    value: "+7",
    type: "ru",
    mask: "(###) ###-##-##"
  },
  {
    value: "+375",
    type: "bel",
    mask: "(###) ###-##-##"
  },
  {
    value: "+381",
    type: "srb",
    mask: "(###) ###-##-##"
  }
];

// ---

const isProfileHasEdited =  ref(false);
const isFormSubmitted = ref(false);

let userFormData = ref({
  firstName: "",
  middleName: "",
  lastName: "",
  phone: "",
  image: "",
  email: "",
  userName: ""
});

const errorList = ref({
  firstName: false,
  middleName: false,
  lastName: false,
  phone: false,
  email: false
});

const setupWatcher = () => {
  watch(userFormData, () => {
    isProfileHasEdited.value = true;
  }, {deep: true});
  watch(activePhoneCode, () => {
    isProfileHasEdited.value = true;
  }, {deep: true});
};

const saveUser = async () => {
  isFormSubmitted.value = true;

  userFormData.value.phone = activePhoneCode.value.phone;
  const form = JSON.parse(JSON.stringify(userFormData.value));

  // Автокоррекция имени и фамилии перед валидацией
  if (form.firstName) form.firstName = formatName(form.firstName);
  if (form.lastName) form.lastName = formatName(form.lastName);
  userFormData.value.firstName = form.firstName;
  userFormData.value.lastName = form.lastName;

  errorList.value = {
    firstName: false,
    middleName: false,
    lastName: false,
    phone: false,
    email: false
  };

  if (form.lastName === null || form.lastName.length <= 0) {
    errorList.value.lastName = t("lk_profile_window.error.required");
  } else {
    errorList.value.lastName = validateName(form.lastName);
  }

  if (form.firstName === null || form.firstName.length <= 0) {
    errorList.value.firstName = t("lk_profile_window.error.required");
  } else {
    errorList.value.firstName = validateName(form.firstName);
  }

  if (form.email !== null && form.email.length > 0) {
    if (!validateEmail(form.email)) {
      errorList.value.email = t("lk_profile_window.error.email_format");
    }
  }

  if (userFormData.value.phone !== null && userFormData.value.phone.length > 0) {
    if (!validatePhone(userFormData.value.phone)) {
      errorList.value.phone = t("lk_profile_window.error.phone_format");
    }
  }

  for (const error in errorList.value) {
    if (errorList.value[error]) {
      isFormSubmitted.value = false;
      return false;
    }
  }

  form.phone = activePhoneCode.value.code + activePhoneCode.value.phone;

  try {
    await userStore.updateUser(form);
    isProfileHasEdited.value = false;
    store.createNotify(t("lk_profile_window.toast.success"), "success");
  } catch (e) {
    store.createNotify(t("lk_profile_window.toast.error"), "error");
  }

  isFormSubmitted.value = false;
};

const validatePhone = (phone) => {
  // const re = /^(\+7|7|8)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/gm;
  const re = /^\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/;
  return re.test(phone);
};

const validateEmail = (email) => {
  const re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

  try {
    const startMail = email.split("@");
    const endMail = startMail[1].split(".");

    if (startMail[0].startsWith("-")) return false;
    if (startMail[0].endsWith("-")) return false;
    if (startMail[0].startsWith("_")) return false;
    if (startMail[0].endsWith("_")) return false;

    if (endMail[0].startsWith("_")) return false;
    if (endMail[0].endsWith("-")) return false;
    if (endMail[0].startsWith("_")) return false;
    if (endMail[0].endsWith("_")) return false;
  } catch {
    return false;
  }

  return re.test(email);
};

const formatName = (name) => {
  name = name.trim().replace(/\s+/g, " ").replace(/\s*-\s*/g, "-");
  return name
    .split(" ")
    .map(word =>
      word
        .split("-")
        .map(part => {
          if (part.length === 0) return part;
          return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        })
        .join("-")
    )
    .join(" ");
};

const validateName = (name) => {
  const specialCharsRegEx = /[!~№?:;"@#$%^*()_+]/;
  if (specialCharsRegEx.test(name)) return t("lk_profile_window.error.special_chars");

  // eslint-disable-next-line
  const emojiRegEx = new RegExp(/[^\x00-\x7Fа-яА-Я]/g)
  const digitRegEx = new RegExp(/[0-9]/g);

  if (digitRegEx.test(name)) return t("lk_profile_window.error.format");
  if (emojiRegEx.test(name)) return t("lk_profile_window.error.format");
  if (name.startsWith("-")) return t("lk_profile_window.error.format");
  if (name.endsWith("-")) return t("lk_profile_window.error.format");

  return false;
};

</script>

<template>
  <div class="windows-wrapper">
    <LKUserAvatar
      :image="userFormData.image"
      @update:image="image => userFormData.image = image"
    />
    <div class="profile">
      <div class="profile__login">
        @{{ userFormData.userName }}
      </div>

      <div class="profile-fullname">
        <div class="profile-input profile-fullname__input">
          <InputPrimary
            v-model="userFormData.lastName"
            required
            :label="t('lk_profile_window.label.lastname')"
            :placeholder="t('lk_profile_window.placeholder.lastname')"
            :error="errorList.lastName"
            :alert="errorList.lastName"
          />
        </div>

        <div class="profile-input profile-fullname__input">
          <InputPrimary
            v-model="userFormData.firstName"
            required
            :label="t('lk_profile_window.label.firstname')"
            :placeholder="t('lk_profile_window.placeholder.firstname')"
            :error="errorList.firstName"
            :alert="errorList.firstName"
          />
        </div>
      </div>

      <div class="profile-input">
        <InputPrimary
          v-model="userFormData.email"
          placeholder="user@globus.ru"
          :error="errorList.email"
          :alert="errorList.email"
          :label="t('lk_profile_window.label.email')"
        />
      </div>

      <div class="profile-input">
        <InputPhone
          v-model="activePhoneCode"
          :phone-code-list="phoneCodeList"
          :label="t('lk_profile_window.label.phone')"
          :error="errorList.phone.length >= 0"
          :alert="errorList.phone"
        />
      </div>

      <div class="profile-control">
        <ButtonAccentPrimary
          :pressed="isFormSubmitted"
          :disabled="!isProfileHasEdited"
          size="large"
          @click="saveUser"
        >
          <EditIcon
            style="color: #FFF; width: 14px; height: 14px;"
          />
          {{ t('lk_profile_window.button.save') }}
        </ButtonAccentPrimary>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

.profile {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;

  &__login {
    color: $grey-dark;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
  }

  &-control {
    display: flex;
    justify-content: flex-end;
    width: 100%;

    &__button {
      min-width: 200px;
    }
  }

  &-fullname {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    &__input {
      flex-grow: 1;
    }
  }

  &-input {
    display: flex;
    flex-direction: column;
    gap: 10px;


  }
}

.windows-wrapper {
  display: flex;
  height: 100%;
  gap: 30px;
}

</style>
